// SPDX-License-Identifier: AGPL-3.0-or-later

export const ExternalUrls = {
	SERVICE_STATUS: 'https://porch.chat',
	SERVICE_STATUS_HISTORY: 'https://porch.chat',
	PRODUCT_HOME: 'https://porch.chat',
} as const;
